// images
import firstImg from "../../images/firstImg.png";
import lfp from "../../images/lfp.png";
import zakat from "../../icons/zacat.png";
import comma from "../../icons/comma.png";
import tr from "../../icons/tr.png";
import trLogo from "../../images/tr-with-logo.png";
import React from 'react';
import tr1 from "../../triangles/tr1.png";
import tr2 from "../../triangles/tr2.png";
import tr3 from "../../triangles/tr3.png";
import tr4 from "../../triangles/tr4.png";
import tr5 from "../../triangles/tr5.png";
import tr6 from "../../triangles/tr6.png";
import tr7 from "../../triangles/tr7.png";
import {Environment} from '../../constants/environment.ts';
import secondIcons from "../../icons/ertikaz-logo.png";
import vision from "../../icons/visionpng.png";
import sma from "../../icons/ertikaz-logo.png";
import thirdIcons from "../../images/1.png";
import thirdIcons2 from "../../images/2.png";
import thirdIcons3 from "../../images/3.png";
import thirdIcons4 from "../../images/4.png";
import thirdIcons5 from "../../images/5.png";
import thirdIcons6 from "../../images/6.png";
import thirdIcons7 from "../../images/7.png";
import thirdIcons8 from "../../images/8.png";
import thirdIcons9 from "../../images/9.png";
import thirdIcons10 from "../../images/10.png";
import thirdIcons11 from "../../images/11.png";
import thirdIcons12 from "../../images/12.png";
import thirdIcons13 from "../../images/13.png";
import thirdIcons14 from "../../images/14.png";
import thirdIcons15 from "../../images/15.png";
import thirdIcons16 from "../../images/16.jpg";
import thirdIcons17 from "../../images/17.jpg";
import thirdIcons18 from "../../images/18.png";
import thirdIcons19 from "../../images/19.png";
import thirdIcons20 from "../../images/20.png";

import f1 from "../../images/f1.png";
import f2 from "../../images/f2.png";
import f3 from "../../images/f3.png";
import fa1 from "../../images/fa1.png";
import fa2 from "../../images/fa2.png";
import fa3 from "../../images/fa3.png";

import fe1 from "../../images/Fast & Simple.png";
import fe2 from "../../images/On The Go.png";
import fe3 from "../../images/Multilingual.png";
import fe4 from "../../images/Dashboard.png";
import fe5 from "../../images/Compliance.png";
import fe6 from "../../images/VAT.png";
import fe7 from "../../images/Customization.png";
import fe8 from "../../images/Collaboration.png";
import fe9 from "../../images/API.png";
import fe10 from "../../images/Modular.png";
import fe11 from "../../images/Scheduling.png";
import fe12 from "../../images/Sharing.png";
import fe13 from "../../images/Security.png";
import fe14 from "../../images/Support.png";
import fe15 from "../../images/Go Green.png";

import c1 from "../../images/The One.png";
import c2 from "../../images/Eskan.png";
import c3 from "../../images/Al Ahsa School (1).png";
import c4 from "../../images/Delta Media.png";

import t1 from "../../icons/t1.png";
import t2 from "../../icons/t2.png";


// Imports
import "./Home.scss";
import { Button, Divider, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import CountUp from "react-countup";

import ScrollTrigger from "react-scroll-trigger";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";

// Swiper 
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { Pagination, Autoplay } from 'swiper';
import 'swiper/css/pagination';

import { HashLink as Hash } from 'react-router-hash-link';

import { useNavigate } from "react-router-dom";

// AOS 

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init({
    duration: 2000,
});

function Home({setActive}) {

    useEffect(() => {
        window.scrollTo(0, 0);
    } , [])
    
    return (
        <div className="Home">
            <First />
            <Second />
            <Third />
            <Fourth />
            <Fifth />
            <Sixth />
            <Seventh />
            <Eight setActive={setActive} />
            <Nine setActive={setActive} />
            <Ten />
        </div>
    );
}

function First() {

    const navigate = useNavigate();
    
    if(localStorage.getItem("lang") === "en") { 
        return (
            <div className="First">
                <div className="tr1">
                    <img src={tr1} alt="" />
                </div>
    
                <div className="container">
                    <Stack
                        direction={{xs : "column" , md : "row"}}
                        justifyContent="space-between"
                        alignItems={{xs : "center" , md : "start"}}
                        spacing={{xs : 20 , md : 44}}
                        pt={{xs : 20 , md :35}}
                        pb={60}
                    >
                        <div className="image">
                            <img src={firstImg} alt="" />
                        </div>
                        <Stack alignItems="center">
                            <Typography
                                color="secondary"
                                sx={{
                                    fontWeight: "700",
                                    fontSize: {xs : "23px" , md : "27px"},
                                    lineHeight: "34px",
                                    textAlign: "center",
                                    mb: 12,
                                }}
                            >
                                Lean Finance is a simple and dynamic online
                                e-Invoicing software that helps you grow your
                                business
                            </Typography>
                            <Typography
                                color="text.secondary"
                                sx={{
                                    fontWeight: "400",
                                    fontSize: "20px",
                                    lineHeight: "24px",
                                    textAlign: "center",
                                    maxWidth: "430px",
                                    mb: 20,
                                }}
                            >
                                Issue, manage, send your ZATCA approved e-Invoices
                                and calculate your tax in seconds.
                            </Typography>
                            <Typography
                                color="text.secondary"
                                sx={{
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    textAlign: "center",
                                    mb: 8,
                                }}
                            >
                                Approved by
                            </Typography>
                            <Stack mb={20}>
                                <img src={zakat} alt="" />
                            </Stack>
                            <Button
                                onClick={() => navigate("/demo")}
                                variant="contained"
                                sx={{ py: 7, px: 16, borderRadius: "14px" , fontSize : "18px" , 
                                lineHeight: "22px",
                                "&:hover": { color: "secondary.main" },
                                }}
                                
                            >
                                <Link to="/demo">Experience it today</Link>
                            </Button>
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    } else {
        return (
            <div className="First">
                <div className="tr1">
                    <img src={tr1} alt="" />
                </div>
    
                <div className="container">
                    <Stack
                        direction={{xs : "column" , md : "row"}}
                        justifyContent="space-between"
                        alignItems={{xs : "center" , md : "start"}}
                        spacing={{xs : 20 , md : 44}}
                        pt={{xs : 20 , md :35}}
                        pb={60}
                    >
                        <div className="image">
                            <img src={firstImg} alt="" />
                        </div>
                        <Stack alignItems="center">
                            <Typography
                                color="secondary"
                                sx={{
                                    fontWeight: "700",
                                    fontSize: {xs : "23px" , md : "27px"},
                                    lineHeight: "34px",
                                    textAlign: "center",
                                    mb: 12,
                                }}
                            >
                                لين فايننس هو برنامج بسيط ومرن لإصدار الفواتير الإلكترونية عبر الإنترنت لمساعدتك على تطوير أعمالك
                            </Typography>
                            <Typography
                                color="text.secondary"
                                sx={{
                                    fontWeight: "400",
                                    fontSize: "20px",
                                    lineHeight: "24px",
                                    textAlign: "center",
                                    maxWidth: "500px",
                                    mb: 20,
                                }}
                            >
                                إصدار، إدارة، إرسال الفواتير الإلكترونية المعتمدة من هيئة الزكاة والضريبة والجمارك وحساب الضريبة الخاصة بك في ثوان.
                            </Typography>
                            <Typography
                                color="text.secondary"
                                sx={{
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    textAlign: "center",
                                    mb: 8,
                                }}
                            >
                                معتمد من قبل
                            </Typography>
                            <Stack mb={20}>
                                <img src={zakat} alt="" />
                            </Stack>
                            <Button
                                onClick={() => navigate("/demo")}
                                variant="contained"
                                sx={{ py: 7, px: 16, borderRadius: "14px" , fontSize : "18px" , 
                                lineHeight: "22px",
                                "&:hover": { color: "secondary.main" },
                                }}
                                
                            >
                                <Link to="/demo">جربه اليوم</Link>
                            </Button>
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    }
}

function Second() {

    const [counterOn, setcounterOn] = useState(false)
    const [apiData,setApiData] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
          const response = await fetch(`${Environment.financeApi}/api/Dashboard/Home`);
          const data = await response.json(); 
          setApiData(data.data);
        };
    
        fetchData();
      }, [setApiData]);
    if(localStorage.getItem("lang") === "en") { 
        return (
            <div className="Second">
                <Stack spacing={20} direction="row" justifyContent="center" mb={10}>
                    <div><img src={secondIcons} alt="" /></div>
                    <div><img src={vision} alt="" /></div>
                </Stack>
                {apiData?
                <Stack
                    direction={{xs : "column" , sm : "row"}}
                    bgcolor="secondary.main"
                    py={20}
                    spacing={{xs : 20 , sm : 58}}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Stack textAlign="center">
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "32px",
                                lineHeight: "39px",
                                mb: 4,
                            }}
                        >
                            <ScrollTrigger 
                                onEnter={() => setcounterOn(true)}
                                onExit={()=> setcounterOn(false)}
                            >
                                {counterOn && 
                                <CountUp
                                    start={0}
                                    end={(apiData.transactions/1000.0)}
                                    duration={2}
                                    decimals={1}
                                    delay={0}
                                />}K
                            </ScrollTrigger>
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "24px",
                            }}
                        >
                            Total Transactions
                        </Typography>
                    </Stack>
                    <Stack textAlign="center">
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "32px",
                                lineHeight: "39px",
                                mb: 4,
                            }}
                        >   
                        <ScrollTrigger 
                                onEnter={() => setcounterOn(true)}
                                onExit={()=> setcounterOn(false)}
                            >
                                {counterOn && 
                                <CountUp
                                    start={0}
                                    end={(apiData.transactionsAmount/1000000000.0)}
                                    duration={2}
                                    decimals={2}
                                    delay={0}
                                    />
                                }B SAR
                            </ScrollTrigger>
                            
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "24px",
                            }}
                        >
                            Total Transactions Amount
                        </Typography>
                    </Stack>
                    <Stack textAlign="center">
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "32px",
                                lineHeight: "39px",
                                mb: 4,
                            }}
                        >
                            <ScrollTrigger 
                                onEnter={() => setcounterOn(true)}
                                onExit={()=> setcounterOn(false)}
                            >
                                {counterOn && 
                                     <CountUp start={0} end={apiData.activeClients} duration={2} />
                                }
                            </ScrollTrigger>
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "24px",
                            }}
                        >
                            Active Clients
                        </Typography>
                    </Stack>
                </Stack>
                :(<div>...</div>)
                }
            </div>
        );
    } else {
        return (
            <div className="Second">
                <Stack spacing={20} direction="row" justifyContent="center" mb={10}>
                    <div><img src={sma} alt="" style={{maxWidth : "151px"}} /></div>
                    <div><img src={vision} alt="" /></div>
                </Stack>
                {apiData?
                (<Stack
                    direction={{xs : "column" , sm : "row"}}
                    bgcolor="secondary.main"
                    py={20}
                    spacing={{xs : 20 , sm : 58}}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Stack textAlign="center">
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "32px",
                                lineHeight: "39px",
                                mb: 4,
                            }}
                        >
                            <ScrollTrigger 
                                onEnter={() => setcounterOn(true)}
                                onExit={()=> setcounterOn(false)}
                            >
                                {counterOn && 
                                <CountUp
                                    start={0}
                                    end={(apiData.transactions/1000.0)}
                                    duration={2}
                                    decimals={1}
                                    delay={0}
                                />} ألف
                            </ScrollTrigger>
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "24px",
                            }}
                        >
                            عدد المعاملات
                        </Typography>
                    </Stack>
                    <Stack textAlign="center">
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "32px",
                                lineHeight: "39px",
                                mb: 4,
                            }}
                        >   
                        <ScrollTrigger 
                                onEnter={() => setcounterOn(true)}
                                onExit={()=> setcounterOn(false)}
                            >
                                {counterOn && 
                                <CountUp
                                    start={0}
                                    end={(apiData.transactionsAmount/1000000000.0)}
                                    duration={2}
                                    decimals={2}
                                    delay={0}
                                    />
                                }مليار ريال
                            </ScrollTrigger>
                            
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "24px",
                            }}
                        >
                            مبلغ المعاملات
                        </Typography>
                    </Stack>
                    <Stack textAlign="center">
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "32px",
                                lineHeight: "39px",
                                mb: 4,
                            }}
                        >
                            <ScrollTrigger 
                                onEnter={() => setcounterOn(true)}
                                onExit={()=> setcounterOn(false)}
                            >
                                {counterOn && 
                                    <CountUp start={0} end={apiData.activeClients} duration={2} />
                                }
                            </ScrollTrigger>
                        </Typography>
                        <Typography
                            sx={{
                                fontWeight: "700",
                                fontSize: "20px",
                                lineHeight: "24px",
                            }}
                        >
                            العملاء النشطين
                        </Typography>
                    </Stack>
                </Stack>)
                :(<div>...</div>)
                }
            </div>
        );
    }
    
}

function Third() {
    if(localStorage.getItem("lang") === "en") { 
        return (
            <div className="Third"> 
                    <Stack pt={20} pb={54} alignItems="center">
                        <Typography
                            color="secondary.main"
                            sx={{
                                fontSize: "28px",
                                fontWeight: "700",
                            }}
                            data-aos="fade-up"
                        >
                            Meet Our Clients
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: {xs : "16px" , sm : "24px"},
                                fontWeight: "400",
                                mb: {xs : 10 , sm : 33},
                                textAlign : "center",
                            }}
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            Proud to have more than 200 clients using Lean Finance
                            to run their business
                        </Typography>
                        <Stack>
                        <div className="container">
                                <Swiper 
                                    slidesPerView={5}
                                    spaceBetween= {0}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 0,
                                        disableOnInteraction: false,
                                    }}
                                    speed={5000}
                                    loop={true}
                                >
                                    <SwiperSlide><img src={thirdIcons} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons2} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons3} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons4} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons5} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons6} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons7} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons8} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons9} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons10} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons11} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons12} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons13} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons14} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons15} alt="" /></SwiperSlide> 
                                    <SwiperSlide><img src={thirdIcons16} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons17} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons18} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons19} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons20} alt="" /></SwiperSlide>
                                </Swiper>
                              
                            </div>
                        </Stack>
                    </Stack> 
            </div>
        );
    } else {
        return (
            <div className="Third">
               
                    <Stack pt={20} pb={54} alignItems="center">
                        <Typography
                            color="secondary.main"
                            sx={{
                                fontSize: "28px",
                                fontWeight: "700",
                            }}
                            data-aos="fade-up"
                        >
                            تعرف على عملائنا
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: {xs : "16px" , sm : "24px"},
                                fontWeight: "400",
                                mb: {xs : 10 , sm : 33},
                                textAlign : "center",
                            }}
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            نفخر بأن لدينا أكثر من 200 عميل يستخدمون لين فايننس لإدارة أعمالهم
                        </Typography>
                        <div className="container">
                            <Swiper 
                                     slidesPerView={5}
                                     spaceBetween= {0}
                                     modules={[Autoplay]}
                                     autoplay={{
                                         delay: 0,
                                         disableOnInteraction: false,
                                     }}
                                     speed={5000}
                                     loop={true}
                                >
                                    <SwiperSlide><img src={thirdIcons} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons2} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons3} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons4} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons5} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons6} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons7} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons8} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons9} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons10} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons11} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons12} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons13} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons14} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons15} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons16} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons17} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons18} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons19} alt="" /></SwiperSlide>
                                    <SwiperSlide><img src={thirdIcons20} alt="" /></SwiperSlide>
                            </Swiper>   
                        </div>
                </Stack>
            </div>
        );
    }
    
}

function Fourth() {
    if(localStorage.getItem("lang") === "en") { 
        return (
            <div className="Fourth" id="industry">
                <img src={tr2} className="tr2" alt="" />
                <div className="container">
                    <Stack py={40} direction={{xs : "column" , md : "row"}} 
                    spacing={{xs : 20 , sm : 75}}>
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "48px",
                                lineHeight: "52px",
                                textAlign : {xs : "center" , sm : "left" }
                            }}
                            data-aos="zoom-in"
                        >
                            Suitable & <br /> customizable <br /> for any industry
                        </Typography>
    
                        <Stack
                            direction={{xs : "column" , sm : "row"}}
                            justifyContent="space-between"
                            flex="1"
                            spacing={{xs: 10 , sm  :0}}
                        >
                            <div><img src={f1} alt="" data-aos="fade-down"  /></div>
                            <div><img src={f2} alt="" data-aos="fade-up" /></div>
                            <div><img src={f3} alt="" data-aos="fade-down" /></div>
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Fourth" id="industry">
                <img src={tr2} className="tr2" alt="" />
                <div className="container">
                    <Stack py={40} direction={{xs : "column" , md : "row"}} 
                    spacing={{xs : 20 , sm : 75}}>
                        <Typography
                            color="white"
                            sx={{
                                fontWeight: "700",
                                fontSize: "48px",
                                lineHeight: "52px",
                                textAlign : {xs : "center" , sm : "left" }
                            }}
                            data-aos="zoom-in"
                        >
                            مناسب وقابل<br /> للتخصيص  لأي<br /> قطاع
                        </Typography>
    
                        <Stack
                            direction={{xs : "column" , sm : "row"}}
                            justifyContent="space-between"
                            flex="1"
                            spacing={{xs: 10 , sm  :0}}
                        >
                            <div><img src={fa1} alt="" data-aos="fade-down"  /></div>
                            <div><img src={fa2} alt="" data-aos="fade-up" /></div>
                            <div><img src={fa3} alt="" data-aos="fade-down" /></div>
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    }
    
}

function Fifth() {

    const [current, setcurrent] = useState(0)

    const features = [
        {
            head : "Fast & Simple",
            paragraphs : [
                "Easily create, edit and mange your documents for your individual and company clients within seconds and get paid faster.",
            ],
            lis : [
                "Invoices.",
                "Credit & debit notes.",
                "Receipt & vouchers."
            ],
            image : fe1,
        },
        {
            head : "On The Go",
            paragraphs : [
                "Access Lean Finance anywhere and anytime from any device.",
                "You can also download our dedicated Lean Finance app from the Google Play and App Store.",
            ],
            image : fe2,
        },
        {
            head : "Multilingual",
            paragraphs : [
                "We know your team is diverse and so Lean Finance supports 4 languages.",
            ],
            lis : [
                "Arabic",
                "English",
                "Urdu",
                "Hindi"
            ],
            image : fe3,
        },
        {
            head : "Dashboard",
            paragraphs : [
                "Comprehensive dashboard to give you an overview of all the software's info.",
            ],
            image : fe4,
        },
        {
            head : "Compliance",
            paragraphs : [
                "Lean Finance is approved by ZATCA allowing it to automatically issues ZATCA compliant invoices. ",
            ],
            image : fe5,
        },
        {
            head : "VAT",
            paragraphs : [
                "Lean Finance allows you to easily calculate and display your tax budget.",
            ],
            image : fe6,
        },
        {
            head : "Customization",
            paragraphs : [
                "Dynamically edit and customize your document templates, software line items and descriptions as needed. ",
            ],
            image : fe7,
        },
        {
            head : "Collaboration",
            paragraphs : [
                "Easily create users with custom permissions to manage your collaboration efforts.",
            ],
            image : fe8,
        },
        {
            head : "API",
            paragraphs : [
                "Lean Finance can be flexibly integrated through APIs with other ERP systems such as:",
            ],
            lis : [
                "SAP",
                "Oracle NetSuite",
                "Microsoft Dynamics",
                "SYSPRO",
                "Epicor",
            ],
            image : fe9,
        },
        {
            head : "Modular",
            paragraphs : [
                "Lean Finance can be further developed and scaled upon based on client’s requirements to ensure that it fits their business and operational processes.  ",
            ],
            image : fe10,
        },
        {
            head : "Automation",
            paragraphs : [
                "Schedule your invoices to automatically issue them periodically or on specific days.",
            ],
            image : fe11,
        },
        {
            head : "Sharing",
            paragraphs : [
                "Instantly share documents with your clients over the phone - SMS, email, WhatsApp or generate a link.",
            ],
            image : fe12,
        },
        {
            head : "Security",
            paragraphs : [
                "Secured software by local and international standards to ease your mind.",
            ],
            image : fe13,
        },
        {
            head : "Support",
            paragraphs : [
                "Free after sales technical support via email or WhatsApp.",
                "Free frequent updates based on ZATCA requirements.",
                "Quick training & knowledge transfer to start using Lean Finance within 10 min.",
            ],
            image : fe14,
        },
        {
            head : "Go Green",
            paragraphs : [
                "Digitize all your documents and help your company support the green initiate.",
            ],
            image : fe15,
        },
    ]

    const featuresA = [
        {
            head : "سريع وبسيط",
            paragraphs : [
                "يمكنك إنشاء مستنداتك وتحريرها وإدارتها لعملائك الأفراد والشركات بمنتهى السهولة وفي غضون ثوانٍ للحصول على الدفعات بشكل أسرع",
            ],
            lis : [
                "الفواتير.",
                "إشعارات الدائن والمدين.",
                " سندات الصرف والقبض."
            ],
            image : fe1,
        },
        {
            head : "أثناء التنقل",
            paragraphs : [
                "استخدام لين فايننس  في أي مكان ووقت من أي جهاز.",
                "يمكنك أيضا تنزيل تطبيق لين فايننس المخصص لإجهزة الاندرويد والايفون",
            ],
            image : fe2,
        },
        {
            head : "متعدد اللغات",
            paragraphs : [
                "نحن نعلم أن فريقك متنوع ولذلك فإن لين فايننس يدعم 4 لغات.",
            ],
            lis : [
                "عربي",
                "إنجليزي",
                "أردو",
                "هندي"
            ],
            image : fe3,
        },
        {
            head : "لوحة التحكم",
            paragraphs : [
                "لوحة تحكم شاملة لإعطائك نظرة عامة على جميع معلومات وبيانات النظام الأساسية.",
            ],
            image : fe4,
        },
        {
            head : "معتمد",
            paragraphs : [
                "تم اعتماد لين فايننس من قبل هيئة الزكاة والضريبة والجمارك مما يسمح لك بإصدار فواتير متوافقة مع المتطلبات تلقائيا.",
            ],
            image : fe5,
        },
        {
            head : "ضريبه القيمه المضافه",
            paragraphs : [
                "يتيح لك لين فايننس حساب ميزانيتك الضريبية وعرضها بسهولة.",
            ],
            image : fe6,
        },
        {
            head : "التخصيص",
            paragraphs : [
                "قم بتخصيص قوالب الفواتير وعناصر النظام الأساسية والأوصاف ديناميكيا حسب الحاجة.",
            ],
            image : fe7,
        },
        {
            head : "التعاون",
            paragraphs : [
                "يمكنك بسهولة إنشاء مستخدمين بأذونات مخصصة لتنظيم والتعاون في إدارة اعمالك.",
            ],
            image : fe8,
        },
        {
            head : "واجهة برمجة التطبيقات",
            paragraphs : [
                "يمكن دمج لين فايننس بمرونة من خلال واجهات برمجة التطبيقات مع أنظمة تخطيط موارد المؤسسات الأخرى مثل :",
            ],
            lis : [
                "SAP",
                "Oracle NetSuite",
                "Microsoft Dynamics",
                "SYSPRO",
                "Epicor",
            ],
            image : fe9,
        },
        {
            head : "نموذجي",
            paragraphs : [
                "يمكن تطوير لين فايننس وتوسيع نطاقه بناءً على متطلباتك للتأكد من أنه يناسب أعمالك والعمليات التشغيلية.",
            ],
            image : fe10,
        },
        {
            head : "التشغيل الآلي",
            paragraphs : [
                "قم بجدولة فواتيرك لإصدارها تلقائيا بشكل دوري أو في أيام محددة .",
            ],
            image : fe11,
        },
        {
            head : "المشاركة",
            paragraphs : [
                "شارك الفواتير على الفور مع عملائك عبر الهاتف - الرسائل القصيرة أو البريد الإلكتروني أو الواتساب أو قم بإنشاء رابط.",
            ],
            image : fe12,
        },
        {
            head : "الأمان",
            paragraphs : [
                "برنامج آمن بالمعايير المحلية والعالمية لراحة بالك .",
            ],
            image : fe13,
        },
        {
            head : "الدعم",
            paragraphs : [
                "دعم فني مجاني بعد البيع عبر البريد الإلكتروني أو  الواتساب.",
                "تحديثات مستمرة مجانية بناء على متطلبات هيئة ضريبة الزكاة والضريبة والجمارك.",
                "تدريب سريع ونقل المعرفة لبدء استخدام لين فايننس في غضون 10 دقائق.",
            ],
            image : fe14,
        },
        {
            head : "كن صديقا للبيئة",
            paragraphs : [
                "قم برقمنة جميع فواتيرك وساعد شركتك على دعم المبادرة الخضراء .",
            ],
            image : fe15,
        },
    ]

    const handleClick = (e) => {
        const liss = document.querySelectorAll(".list li")
        liss.forEach((li) => {
            li.classList.remove("active")
        })
        e.target.classList.add("active")
        setcurrent(e.target.dataset.num)
    }

    const navigate = useNavigate()

    if(localStorage.getItem("lang") === "en") { 
        return (
            <div className="Fifth" id="features">
                <img src={tr3} className="tr3" alt="" />
                <img src={tr4} className="tr4" alt="" />
    
                <div className="container">
                    <Typography
                        color="white"
                        sx={{
                            fontWeight: "700",
                            fontSize: {xs : "40px" , sm : "48px"},
                            lineHeight: "50px",
                            textAlign: "center",
                        }}
                    >
                        Essential Features
                    </Typography>
                    <Typography
                        color="primary"
                        sx={{
                            fontWeight: "700",
                            fontSize: {xs : "20px" , sm : "32px"},
                            lineHeight: "51px",
                            textAlign: "center",
                            mb: 20,
                        }}
                    >
                        Simplifying your e-invoicing process
                    </Typography>
    
                    <div className="box">
                        {/* desktop */}
                        <Stack
                            display={{xs : "none" , md : "flex"}}
                            direction={{xs : "row" , md : "row"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={24}
                            className="list"
                        >
                            <li data-num="0" onClick={(e) => handleClick(e) } className="active" >Fast & Simple</li>
                            <li data-num="1" onClick={(e) => handleClick(e) } >On The Go</li>
                            <li data-num="2" onClick={(e) => handleClick(e) }>Multilingual</li>
                            <li data-num="3" onClick={(e) => handleClick(e) }>Dashboard</li>
                            <li data-num="4" onClick={(e) => handleClick(e) }>Compliance </li>
                            <li data-num="5" onClick={(e) => handleClick(e) }>VAT</li>
                            <li data-num="6" onClick={(e) => handleClick(e) }>Customization</li>
                            <li data-num="7" onClick={(e) => handleClick(e) }>Collaboration</li>
                            <li data-num="8" onClick={(e) => handleClick(e) }>API</li>
                            <li data-num="9" onClick={(e) => handleClick(e) }>Modular</li>
                            <li data-num="10" onClick={(e) => handleClick(e) }>Automation</li>
                            <li data-num="11" onClick={(e) => handleClick(e) }>Sharing</li>
                            <li data-num="12" onClick={(e) => handleClick(e) }>Security</li>
                            <li data-num="13" onClick={(e) => handleClick(e) }>Support</li>
                            <li data-num="14" onClick={(e) => handleClick(e) }>Go Green</li>
                        </Stack>
                        {/* mobile */}
                        <Stack
                            display={{xs : "flex" , md : "none"}}
                            direction={{xs : "row" , md : "row"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={10}
                            className="list"
                        >
                            <li data-num="0" onClick={(e) => handleClick(e) } className="active" >Fast & Simple</li>
                            <li data-num="1" onClick={(e) => handleClick(e) } >On The Go</li>
                            <li data-num="2" onClick={(e) => handleClick(e) }>Multilingual</li>
                            <li data-num="3" onClick={(e) => handleClick(e) }>Dashboard</li>
                        </Stack>
                        <Stack
                            direction={{xs : "row" , md : "row"}}
                            display={{xs : "flex" , md : "none"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={10}
                            className="list"
                        >
                            <li data-num="4" onClick={(e) => handleClick(e) }>Compliance </li>
                            <li data-num="5" onClick={(e) => handleClick(e) }>VAT</li>
                            <li data-num="6" onClick={(e) => handleClick(e) }>Customization</li>
                            <li data-num="7" onClick={(e) => handleClick(e) }>Collaboration</li>
                            <li data-num="8" onClick={(e) => handleClick(e) }>API</li>
                        </Stack>
                        <Stack
                            direction={{xs : "row" , md : "row"}}
                            display={{xs : "flex" , md : "none"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={24}
                            className="list"
                        >
                            <li data-num="9" onClick={(e) => handleClick(e) }>Modular</li>
                            <li data-num="10" onClick={(e) => handleClick(e) }>Automation</li>
                            <li data-num="11" onClick={(e) => handleClick(e) }>Sharing</li>
                            <li data-num="12" onClick={(e) => handleClick(e) }>Security</li>
                            <li data-num="13" onClick={(e) => handleClick(e) }>Support</li>
                            <li data-num="14" onClick={(e) => handleClick(e) }>Go Green</li>
                        </Stack>
    
    
                        <Stack
                            // spacing={50}
                            justifyContent="space-around"
                            direction={{xs : "column" , md : "row"}}
                            spacing={{xs : 20 , md : 0}}
                        >
                            <Stack>
                                <Typography
                                    sx={{
                                        fontSize: "32px",
                                        fontWeight: "700",
                                        lineHeight: "48px",
                                        mb: {xs : 10 , md : 20},
                                    }}
                                >
                                    {features[current].head}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "21px",
                                        fontWeight: "400",
                                        lineHeight: "30px",
                                        maxWidth: {xs : "100%" , md : "350px"},
                                        mb: {xs : 5 , md : 18},
                                    }}
                                >
                                    {features[current].paragraphs && features[current].paragraphs.map((paragraph , i) => {
                                        return (
                                            <div key={i} >{paragraph} <br /> <br /> </div>
                                        )
                                    })}
                                </Typography>
                                {features[current].lis && 
                                    <ul>
                                        {features[current].lis && features[current].lis.map((li , i) => {
                                            return (
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={8}
                                                    key={i}
                                                >
                                                    <div className="icon">
                                                        <img src={tr} alt="" />
                                                    </div>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "400",
                                                            fontSize: "21px",
                                                        }}
                                                    >
                                                        {li}
                                                    </Typography>
                                                </Stack>
                                            )
                                        })}
                                    </ul>
                                }
                                <Button
                                    onClick={() => navigate("/demo")}
                                    variant="contained"
                                    sx={{
                                        py: 8,
                                        px: 35,
                                        width: "fit-Content",
                                        borderRadius: "16px",
                                        "&:hover": { color: "secondary.main" },
                                    }}
                                >
                                    <Link to="/demo">Start now</Link>
                                </Button>
                            </Stack>
    
                            <div className="image">
                                <img src={features[current].image} alt="" />
                            </div>
                        </Stack>
    
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Fifth" id="features">
                <img src={tr3} className="tr3" alt="" />
                <img src={tr4} className="tr4" alt="" />
    
                <div className="container">
                    <Typography
                        color="white"
                        sx={{
                            fontWeight: "700",
                            fontSize: {xs : "40px" , sm : "48px"},
                            lineHeight: "50px",
                            textAlign: "center",
                        }}
                    >
                        الميزات الأساسية
                    </Typography>
                    <Typography
                        color="primary"
                        sx={{
                            fontWeight: "700",
                            fontSize: {xs : "20px" , sm : "32px"},
                            lineHeight: "51px",
                            textAlign: "center",
                            mb: 20,
                        }}
                    >
                        تبسيط عملية الفوترة الإلكترونية 
                    </Typography>
    
                    <div className="box">
                        {/* desktop */}
                        <Stack
                            display={{xs : "none" , md : "flex"}}
                            direction={{xs : "row" , md : "row"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={24}
                            className="list"
                        >
                            <li data-num="0" onClick={(e) => handleClick(e) } className="active" >سريع وبسيط</li>
                            <li data-num="1" onClick={(e) => handleClick(e) } >أثناء التنقل</li>
                            <li data-num="2" onClick={(e) => handleClick(e) }>متعدد اللغات</li>
                            <li data-num="3" onClick={(e) => handleClick(e) }>لوحة التحكم</li>
                            <li data-num="4" onClick={(e) => handleClick(e) }>معتمد </li>
                            <li data-num="5" onClick={(e) => handleClick(e) }>ضريبه القيمه المضافه</li>
                            <li data-num="6" onClick={(e) => handleClick(e) }>التخصيص</li>
                            <li data-num="7" onClick={(e) => handleClick(e) }>التعاون</li>
                            <li data-num="8" onClick={(e) => handleClick(e) }>واجهة برمجة التطبيقات</li>
                            <li data-num="9" onClick={(e) => handleClick(e) }>نموذجي</li>
                            <li data-num="10" onClick={(e) => handleClick(e) }>التشغيل الآلي</li>
                            <li data-num="11" onClick={(e) => handleClick(e) }>المشاركة</li>
                            <li data-num="12" onClick={(e) => handleClick(e) }>الأمان</li>
                            <li data-num="13" onClick={(e) => handleClick(e) }>الدعم</li>
                            <li data-num="14" onClick={(e) => handleClick(e) }>كن صديقا للبيئة</li>
                        </Stack>
                        {/* mobile */}
                        <Stack
                            display={{xs : "flex" , md : "none"}}
                            direction={{xs : "row" , md : "row"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={10}
                            className="list"
                        >
                            <li data-num="0" onClick={(e) => handleClick(e) } className="active" >سريع وبسيط</li>
                            <li data-num="1" onClick={(e) => handleClick(e) } >ثناء التنقل</li>
                            <li data-num="2" onClick={(e) => handleClick(e) }>متعدد اللغات</li>
                            <li data-num="3" onClick={(e) => handleClick(e) }>لوحة التحكم</li>
                            <li data-num="4" onClick={(e) => handleClick(e) }>معتمد </li>
                        </Stack>
                        <Stack
                            direction={{xs : "row" , md : "row"}}
                            display={{xs : "flex" , md : "none"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={10}
                            className="list"
                        >
                            <li data-num="5" onClick={(e) => handleClick(e) }>ضريبه القيمه المضافه</li>
                            <li data-num="6" onClick={(e) => handleClick(e) }>التخصيص</li>
                            <li data-num="7" onClick={(e) => handleClick(e) }>التعاون</li>
                            <li data-num="8" onClick={(e) => handleClick(e) }>واجهة برمجة التطبيقات</li>
                        </Stack>
                        <Stack
                            direction={{xs : "row" , md : "row"}}
                            display={{xs : "flex" , md : "none"}}
                            divider={
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ bgcolor: "secondary.main" }}
                                />
                            }
                            alignItems="center"
                            justifyContent="space-between"
                            py={6}
                            px={8}
                            border="1px solid"
                            borderColor="text.primary"
                            borderRadius="16px"
                            mb={24}
                            className="list"
                        >
                            <li data-num="9" onClick={(e) => handleClick(e) }>نموذجي</li>
                            <li data-num="10" onClick={(e) => handleClick(e) }>التشغيل الآلي</li>
                            <li data-num="11" onClick={(e) => handleClick(e) }>المشاركة</li>
                            <li data-num="12" onClick={(e) => handleClick(e) }>الأمان</li>
                            <li data-num="13" onClick={(e) => handleClick(e) }>دعم</li>
                            <li data-num="14" onClick={(e) => handleClick(e) }>كن صديقا للبيئة</li>
                        </Stack>
    
    
                        <Stack
                            // spacing={50}
                            justifyContent="space-around"
                            direction={{xs : "column" , md : "row"}}
                            spacing={{xs : 20 , md : 0}}
                        >
                            <Stack>
                                <Typography
                                    sx={{
                                        fontSize: "32px",
                                        fontWeight: "700",
                                        lineHeight: "48px",
                                        mb: {xs : 10 , md : 20},
                                    }}
                                >
                                    {featuresA[current].head}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: "21px",
                                        fontWeight: "400",
                                        lineHeight: "30px",
                                        maxWidth: {xs : "100%" , md : "350px"},
                                        mb: {xs : 5 , md : 18},
                                    }}
                                >
                                    {featuresA[current].paragraphs && featuresA[current].paragraphs.map((paragraph , i) => {
                                        return (
                                            <div key={i} >{paragraph} <br /> <br /> </div>
                                        )
                                    })}
                                </Typography>
                                {featuresA[current].lis && 
                                    <ul>
                                        {featuresA[current].lis && featuresA[current].lis.map((li , i) => {
                                            return (
                                                <Stack
                                                    direction="row"
                                                    alignItems="center"
                                                    spacing={8}
                                                    key={i}
                                                >
                                                    <div className="icon">
                                                        <img src={tr} alt="" />
                                                    </div>
                                                    <Typography
                                                        sx={{
                                                            fontWeight: "400",
                                                            fontSize: "21px",
                                                        }}
                                                    >
                                                        {li}
                                                    </Typography>
                                                </Stack>
                                            )
                                        })}
                                    </ul>
                                }
                                <Button
                                    onClick={() => navigate("/demo")}
                                    variant="contained"
                                    sx={{
                                        py: 8,
                                        px: 35,
                                        width: "fit-Content",
                                        borderRadius: "16px",
                                        "&:hover": { color: "secondary.main" },
                                    }}
                                >
                                    <Link to="/demo">ابدأ الان</Link>
                                </Button>
                            </Stack>
    
                            <div className="image">
                                <img src={features[current].image} alt="" />
                            </div>
                        </Stack>
    
                    </div>
                </div>
            </div>
        );
    }
    
    
}

function Sixth() {
    if(localStorage.getItem("lang") === "en") {
        return (
            <div className="Sixth">
                <img src={tr5} className="tr5" alt="" />
                <div className="container">
                    <Typography
                        color="text.secondary"
                        sx={{
                            fontWeight: "700",
                            fontSize: "30px",
                            lineHeight: "48px",
                            textAlign: "center",
                        }}
                    >
                        Case Studies
                    </Typography>
                    <hr />
                    <Swiper
                        modules={[Pagination , Autoplay]}
                        pagination={{clickable : true}}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        loop
                        speed={1000}
                    >
                        <SwiperSlide>
                            <Stack
                                justifyContent="space-between"
                                spacing={20}
                                direction={{xs : "column" , md : "row"}}
                                pb="80px"
                            >
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c1} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            The ONE Logistics
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            The One Logistics is a company specializing in moving exotic luxury vehicles around the world by Sea, Air & Road.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs1">View case study</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c2} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            Eskan Salman
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            Eskan Salman are a real estate developer and financier for those looking to buy or rent.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs2">View case study</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                            </Stack>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Stack
                                justifyContent="space-between"
                                spacing={20}
                                direction={{xs : "column" , md : "row"}}
                            >
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c3} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            Al-AHSA Model Schools
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            A school aiming to raise the educational efficiency of the teacher and student through modern strategies in learning.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs3">View case study</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c4} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            Delta Media
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            Production studio providing Saudi TV channels with news, reports and  documentaries from around the world.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs4">View case study</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                            </Stack>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Sixth">
                <img src={tr5} className="tr5" alt="" />
                <div className="container">
                    <Typography
                        color="text.secondary"
                        sx={{
                            fontWeight: "700",
                            fontSize: "30px",
                            lineHeight: "48px",
                            textAlign: "center",
                        }}
                    >
                        دراسات الحالة
                    </Typography>
                    <hr />
                    <Swiper
                        modules={[Pagination , Autoplay]}
                        pagination={{clickable : true}}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}
                        loop
                        speed={1000}
                    >
                        <SwiperSlide>
                            <Stack
                                justifyContent="space-between"
                                spacing={20}
                                direction={{xs : "column" , md : "row"}}
                                pb="80px"
                                className="right"
                            >
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c1} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            اللوجستي الاول 
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            اللوجستي الاول هي شركة متخصصة في نقل المركبات الفاخرة والفريدة حول العالم عن طريق البحر والجو والبر.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs1">عرض الدراسة</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c2} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            إسكان سلمان العقارية
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            إسكان سلمان هو مطور عقاري وممول لأولئك الذين يتطلعون إلى الشراء أو الإيجار.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs2">عرض الدراسة</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                            </Stack>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Stack
                                justifyContent="space-between"
                                spacing={20}
                                direction={{xs : "column" , md : "row"}}
                                className="right"
                            >
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c3} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            مدارس الأحساء النموذجية
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            مدرسة تستخدم الاستراتيجيات الحديثة في التعليم لرفع الكفاءة التعليمية للمعلم والطالب.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs3">عرض الدراسة</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                                <Stack
                                    flex="1"
                                    direction={{xs : "column" , sm : "row"}}
                                    spacing={14}
                                    alignItems={{xs : "start" , sm : "center"}}
                                >
                                    <img src={c4} alt="" />
                                    <div className="content">
                                        <Typography
                                            color="secondary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "28px",
                                                lineHeight: "34px",
                                                mb: 8,
                                            }}
                                        >
                                            دلتا ميديا
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontWeight: "400",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                mb: 8,
                                                maxWidth : {xs : "400px" , sm : "100%"}
                                            }}
                                        >
                                            استوديو إنتاج يزود القنوات التلفزيونية السعودية بالأخبار والتقارير والأفلام الوثائقية من جميع أنحاء العالم.
                                        </Typography>
                                        <Typography
                                            color="primary"
                                            sx={{
                                                fontWeight: "700",
                                                fontSize: "20px",
                                                lineHeight: "20px",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            <Hash to="/caseStudy#cs4">عرض الدراسة</Hash>
                                        </Typography>
                                    </div>
                                </Stack>
                            </Stack>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        );
    }
}

function Seventh() {

    if(localStorage.getItem("lang") === "en") {
        return (
            <div className="Seventh">
                <img src={tr6} alt="" className="tr6" />
                <img src={tr7} alt="" className="tr7" />
    
                <div className="container">
                    <Stack direction={{xs : "column" , md :"row"}} spacing={16} alignItems={{xs : "start" , md :"center"}}>
                        <Typography
                            color="primary"
                            sx={{
                                fontWeight: "700",
                                fontSize: "40px",
                                lineHeight: "40px",
                            }}
                        >
                            Our <br /> clients <br /> love our <br /> platform!
                        </Typography>
    
                        <Stack
                            py={12}
                            pl={{xs : 10 , md : 65}}
                            pr={{xs: 10 , md : 20}}
                            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.08)"
                            borderRadius="12px"
                        >
                        
                            <Swiper 
                                modules={[Autoplay , Pagination]}
                                pagination={{clickable : true}}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                loop
                                speed={1000}
                            >
                                <SwiperSlide>
                                    <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , md :40}} alignItems={{xs : "center" , md : "start"}}>
                                        <Stack spacing={8}>
                                            <Typography color="secondary"
                                                sx={{
                                                    fontWeight: "700",
                                                    fontSize: "28px",
                                                    lineHeight: "28px",
                                                    minWidth: "140px",
                                                }}
                                            >
                                                Makarim <br /> Al Shemal
                                            </Typography>
                                            <img src={t1} alt="" style={{maxHeight : "110px" , maxWidth : "108px"}} />
                                        </Stack>
    
                                        <Stack direction="row" spacing={12}>
                                            <div>
                                                <img src={comma} alt="" />
                                            </div>
                                            <Stack>
                                                <Typography
                                                    color="secondary"
                                                    sx={{
                                                        fontWeight: "400",
                                                        fontSize: {xs: "16px" , md: "24px"},
                                                        lineHeight: "26px",
                                                        mb: 8,
                                                    }}
                                                >
                                                    Lean Finance is very simple to use, flexible
                                                    and adaptive, generates detailed results and
                                                    accessing it from any device is great. Im
                                                    very satisfied with Lean Finance and
                                                    grateful for Ertikaz Solution’s 24 hour
                                                    support.
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "700",
                                                        fontSize: {xs: "16px" , md: "20px"},
                                                        lineHeight: "32px",
                                                        fontStyle: "italic",
                                                        mb: 8,
                                                    }}
                                                >
                                                    Owner
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , md :40}} alignItems={{xs : "center" , md : "start"}}>
    
                                        <Stack spacing={8} alignItems="center">
                                            <Typography color="secondary"
                                                sx={{
                                                    fontWeight: "700",
                                                    fontSize: "28px",
                                                    lineHeight: "28px",
                                                    minWidth: "140px",
                                                }}
                                            >
                                                Wings Intl. Contracting
                                            </Typography>
                                            <img src={t2} alt="" className="t2" />
                                        </Stack>
    
                                        <Stack direction="row" spacing={12}>
                                            <div>
                                                <img src={comma} alt="" />
                                            </div>
                                            <Stack>
                                                <Typography
                                                    color="secondary"
                                                    sx={{
                                                        fontWeight: "400",
                                                        mb: 8,
                                                        fontSize: {xs: "16px" , md: "24px"},
                                                    }}
                                                >
                                                    Lean Finance is amazing and using it is so simple, I’m impressed with all that it has to offer. 
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "700",
                                                        fontSize: {xs: "16px" , md: "20px"},lineHeight: "32px",
                                                        fontStyle: "italic",
                                                        mb: 8,
                                                    }}
                                                >
                                                    Owner
                                                </Typography>
                                            </Stack>
                                        </Stack>
    
                                    </Stack>
                                </SwiperSlide>
                            </Swiper>
                        
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Seventh">
                <img src={tr6} alt="" className="tr6" />
                <img src={tr7} alt="" className="tr7" />
    
                <div className="container">
                    <Stack direction={{xs : "column" , md :"row"}} spacing={16} alignItems={{xs : "start" , md :"center"}}>
                        <Typography
                            color="primary"
                            sx={{
                                fontWeight: "700",
                                fontSize: "40px",
                                lineHeight: "40px",
                            }}
                        >
                            عملاؤنا <br /> يحبون <br /> منصتنا!
                        </Typography>
    
                        <Stack
                            py={12}
                            pl={{xs : 10 , md : 65}}
                            pr={{xs: 10 , md : 20}}
                            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.08)"
                            borderRadius="12px"
                        >
                        
                            <Swiper 
                                modules={[Autoplay , Pagination]}
                                pagination={{clickable : true}}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                loop
                                speed={1000}
                            >
                                <SwiperSlide>
                                    <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , md :40}} alignItems={{xs : "center" , md : "start"}}
                                    className="right"
                                    >
                                        <Stack spacing={8}>
                                            <Typography color="secondary"
                                                sx={{
                                                    fontWeight: "700",
                                                    fontSize: "28px",
                                                    lineHeight: "28px",
                                                    minWidth: "140px",
                                                }}
                                            >
                                                مكارم <br /> الشمال
                                            </Typography>
                                            <img src={t1} alt="" style={{maxHeight : "110px" , maxWidth : "108px"}} />
                                        </Stack>
    
                                        <Stack direction="row" spacing={12}>
                                            <div>
                                                <img src={comma} alt="" />
                                            </div>
                                            <Stack>
                                                <Typography
                                                    color="secondary"
                                                    sx={{
                                                        fontWeight: "400",
                                                        fontSize: {xs: "16px" , md: "24px"},
                                                        lineHeight: "26px",
                                                        mb: 8,
                                                    }}
                                                >
                                                    برنامج لين فايننس سهل الاستخدام للغاية ومرن وقابل للتكيف، يعطي نتائج مفصلة والدخول إليه من أي جهاز أمر رائع، أنا مرتاح جداً مع لين فايننس وأشعر بالامتنان لدعم ارتكاز سولوشنز المتواصل على مدار الساعة.
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "700",
                                                        fontSize: {xs: "16px" , md: "20px"},
                                                        lineHeight: "32px",
                                                        fontStyle: "italic",
                                                        mb: 8,
                                                    }}
                                                >
                                                    المالك
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <Stack direction={{xs : "column" , md : "row"}} spacing={{xs : 20 , md :40}} alignItems={{xs : "center" , md : "start"}}
                                    className="right">
    
                                        <Stack spacing={8} alignItems="center">
                                            <Typography color="secondary"
                                                sx={{
                                                    fontWeight: "700",
                                                    fontSize: "28px",
                                                    lineHeight: "28px",
                                                    minWidth: "140px",
                                                }}
                                            >
                                                وينجز الدولية للمقاولات
                                            </Typography>
                                            <img src={t2} alt="" className="t2" />
                                        </Stack>
    
                                        <Stack direction="row" spacing={12}>
                                            <div>
                                                <img src={comma} alt="" />
                                            </div>
                                            <Stack>
                                                <Typography
                                                    color="secondary"
                                                    sx={{
                                                        fontWeight: "400",
                                                        mb: 8,
                                                        fontSize: {xs: "16px" , md: "24px"},
                                                    }}
                                                >
                                                    انا معجب بكل ما يقدمه لين فايننس، انه مذهل واستخدامه سهل للغايه.
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "700",
                                                        fontSize: {xs: "16px" , md: "20px"},lineHeight: "32px",
                                                        fontStyle: "italic",
                                                        mb: 8,
                                                    }}
                                                >
                                                    المالك
                                                </Typography>
                                            </Stack>
                                        </Stack>
    
                                    </Stack>
                                </SwiperSlide>
                            </Swiper>
                        
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    }
    
    
    
}

function Eight({setActive}) {
    if (localStorage.getItem("lang") === "en") {
        return (
            <div className="Eight">
                <div className="container">
                    <Stack
                        direction={{xs : "column" , md : "row"}}
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={{xs : 20 , md : 0}}
                    >
                        <img className="trLogo" src={trLogo} alt="" />
                        <Stack>
                            <Typography
                                color="white"
                                sx={{
                                    fontWeight: "700",
                                    fontSize: "40px",
                                    lineHeight: "40px",
                                    mb: 12,
                                    textAlign : {xs : "center", md : "left"}
                                }}
                            >
                                Flexible and <br /> customizable <br /> pricing
                                scheme
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{ py: 8, px: 22, borderRadius: "12px" , 
                                    "&:hover" : {
                                        color : "secondary.main"
                                    }
                                }}
                                onClick={() => setActive(true)}
                            >
                                Contact us for a quote
                            </Button>
                        </Stack>
                        <Stack pb = {{xs : 10 , md : 0}}>
                            <Button
                                variant="outlined"
                                sx={{
                                    py: 8,
                                    px: 32,
                                    borderRadius: "16px",
                                    color: "white",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                    border: "1px solid",
                                    borderColor: "white",
                                    mb: 8,
                                    lineHeight : "40px",
                                    cursor : "default",
                                    "&:hover": { borderColor: "white", bgcolor : "transparent" },
                                }}
                            >
                                Lean Finance
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    py: 8,
                                    px: 32,
                                    borderRadius: "16px",
                                    color: "white",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                    border: "1px solid",
                                    borderColor: "white",
                                    cursor : "default",
                                    lineHeight : "40px",
                                    "&:hover": { borderColor: "white", bgcolor : "transparent" },
                                }}
                            >
                                Lean Finance Pro
                            </Button>
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Eight">
                <div className="container">
                    <Stack
                        direction={{xs : "column" , md : "row"}}
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={{xs : 20 , md : 0}}
                    >
                        <img className="trLogo" src={trLogo} alt="" />
                        <Stack>
                            <Typography
                                color="white"
                                sx={{
                                    fontWeight: "700",
                                    fontSize: "40px",
                                    lineHeight: "40px",
                                    mb: 12,
                                    textAlign : "center",
                                }}
                            >
                                نظام تسعير <br /> مرن وقابل <br /> للتخصيص
                            </Typography>
                            <Button
                                variant="contained"
                                sx={{ py: 8, px: 22, borderRadius: "12px", 
                                "&:hover" : {
                                    color : "secondary.main"
                                } }}
                                onClick={() => setActive(true)}
                            >
                                اتصل بنا
                            </Button>
                        </Stack>
                        <Stack pb = {{xs : 10 , md : 0}}>
                            <Button
                                variant="outlined"
                                sx={{
                                    py: 8,
                                    px: 32,
                                    borderRadius: "16px",
                                    color: "white",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                    border: "1px solid",
                                    borderColor: "white",
                                    mb: 8,
                                    lineHeight : "40px",
                                    cursor : "default",
                                    "&:hover": { borderColor: "white" , bgcolor : "transparent" },
                                }}
                            >
                                لين فايننس
                            </Button>
                            <Button
                                variant="outlined"
                                sx={{
                                    py: 8,
                                    px: 32,
                                    borderRadius: "16px",
                                    color: "white",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                    border: "1px solid",
                                    borderColor: "white",
                                    cursor : "default",
                                    lineHeight : "40px",
                                    "&:hover": { borderColor: "white", bgcolor : "transparent" },
                                }}
                            >
                                لين فايننس برو
                            </Button>
                        </Stack>
                    </Stack>
                </div>
            </div>
        );
    }
}

function Nine({setActive}) {

    if (localStorage.getItem("lang") === "en") {
        return (
            <div className="Nine">
                <div className="container">
                    <Stack
                        direction={{xs : "column-reverse" , md : "row"}}
                        justifyContent="space-between"
                        alignItems={{xs : "center" , md : "start"}}
                        spacing={{xs : 20 , md :40}}
                    >
                        <Stack alignItems="center">
                            <Typography
                                color="white"
                                sx={{
                                    fontWeight: "700",
                                    fontSize: {xs : "35px" , md : "42px"},
                                    lineHeight: "50px",
                                    textAlign: " center",
                                    mb: 16,
                                }}
                            >
                                Looking for an <span>inventory management</span> &{" "}
                                <span>e-invoicing</span> platform?
                            </Typography>
                            <Typography
                                color="white"
                                sx={{
                                    fontWeight: "400",
                                    fontSize: "24px",
                                    lineHeight: "30px",
                                    textAlign: " center",
                                    mb: 32,
                                }}
                            >
                                Create, edit and manage your{" "}
                                <strong>Product Inventory</strong>,{" "}
                                <strong>Purchasing</strong>, <br /> <strong>Sales</strong>,{" "}
                                <strong>Spending</strong>,{" "}
                                <strong>Suppliers</strong> and{" "}
                                <strong>Expenses</strong> seamlessly.
                            </Typography>
                            <Button
                                color="secondary"
                                variant="contained"
                                sx={{
                                    py: 8,
                                    px: 12,
                                    borderRadius: "16px",
                                    width: "fit-content",
                                    color : "white",
                                    "&:hover": { color: "primary.main" },
                                }}
                                onClick={() => setActive(true)}
                            >
                                Contact us to learn more
                            </Button>
                        </Stack>
                        <div>
                            <img src={lfp} alt="" />
                        </div>
                    </Stack>
                </div>
            </div>
        );
    } else {
        return (
            <div className="Nine">
                <div className="container">
                    <Stack
                        direction={{xs : "column-reverse" , md : "row"}}
                        justifyContent="space-between"
                        alignItems={{xs : "center" , md : "start"}}
                        spacing={{xs : 20 , md :40}}
                    >
                        <Stack alignItems="center">
                            <Typography
                                color="white"
                                sx={{
                                    fontWeight: "700",
                                    fontSize: {xs : "35px" , md : "42px"},
                                    lineHeight: "50px",
                                    textAlign: " center",
                                    mb: 16,
                                }}
                            >
                                
                                هل تبحث عن برنامج <span>لإدارة المخزون </span>{" "}
                                <span>والفوترة الإلكترونية</span> ؟
                            </Typography>
                            <Typography
                                color="white"
                                sx={{
                                    fontWeight: "400",
                                    fontSize: "24px",
                                    lineHeight: "30px",
                                    textAlign: " center",
                                    mb: 32,
                                }}
                            >
                                قم بإنشاء وتعديل وإدارة {" "}
                                <strong>مخزون المنتجات</strong>,{" "}
                                <strong>والمشتريات</strong>, <br /> <strong>والمبيعات</strong>,{" "}
                                <strong>والإنفاق</strong>,{" "}
                                <strong>والموردين</strong>{" "}
                                <strong>والمصروفات</strong> بحرفية وبكل سلاسة.
                            </Typography>
                            <Button
                                color="secondary"
                                variant="contained"
                                sx={{
                                    py: 8,
                                    px: 12,
                                    borderRadius: "16px",
                                    width: "fit-content",
                                    color : "white",
                                    "&:hover": { color: "primary.main" },
                                }}
                                onClick={() => setActive(true)}
                            >
                                اتصل بنا
                            </Button>
                        </Stack>
                        <div>
                            <img src={lfp} alt="" />
                        </div>
                    </Stack>
                </div>
            </div>
        );
    }
    
    
}

function Ten() {

    if(localStorage.getItem("lang") === "en") {
        return (
            <div className="Ten">
                <div className="container">
                    
                    <Accordion
                        sx={{
                            borderTop: "none",
                            borderBottom: "none",
                            boxShadow: "none",
                            borderRadius: "0",
                            borderColor: "#BCBEC0",
                            py: 5,
                        }}
                    >
                        <AccordionSummary
                            expandIcon={
                                <ExpandMoreIcon
                                    color="secondary"
                                    fontSize="large"
                                    sx={{
                                        "&:hover": {
                                            color: "primary.main",
                                        },
                                    }}
                                />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography
                                sx={{
                                    fontWeight: "700",
                                    fontSize: "40px",
                                    lineHeight: "64px",
                                    color: "text.secondary",
                                    textAlign: "center",
                                    mb: 20,
                                    width : "100%"
                                }}
                            >
                                FAQ
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                                <hr />
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        What is SaaS?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        SaaS mean software as a service which is a cloud
                                        based software that allows users to easily access it
                                        from anywhere.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        What is an online e-invoicing software?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Is a cloud based software that allows you to do all
                                        operations and store documents on the cloud without
                                        the need to have them on your devices.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        What is a ZATCA?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        ZATCA is Saudi Arabia’s Zakat, Tax, and Customs
                                        Authority which has requirements necessary for
                                        invoices.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        What are ZATCA approved invoices?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Are invoices generated from an e-invoicing software
                                        approved and linked to the authority.
                                        <br />
                                        They include the company’s tax registration number
                                        and an automatically generated QR code.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I issue an invoice, debit or credit note?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To issue an invoice, debit or credit note from Lean
                                        Finance all you need to do is: <br />
                                        <li> <strong>Login</strong> to your account.</li>
                                        <li> Go to <strong>Sales</strong> page from main menu.</li>
                                        <li> Click the <strong>Create Invoice</strong> Button.</li>
                                        <li> Fill in the needed information.</li>
                                        <li> Click <strong>Create</strong> to issue your invoice.</li>
                                        <li> Issued <strong>invoices</strong> are listed in the <strong>Sales</strong> page.</li>
                                        <li> Same process is done for the <strong>Debit & Credit notes</strong>.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I add products for my invoicing?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To add a products on Lean Finance all you need to do
                                        is: <br /> 
                                        <li> <strong>Login</strong> to your account. </li>
                                        <li> Go to the <strong>Products</strong> page from main menu.</li>
                                        <li> Click the <strong>Add Product</strong> Button. </li>
                                        <li> Fill in the needed information.</li>
                                        <li> Click <strong>Create Product</strong> to add your product. </li>
                                        <li> Newly added <strong>Products</strong> are listed in the <strong>Products</strong> page.</li>
                                        
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I customize my invoice template?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To customize your invoice template on Lean Finance
                                        all you need to do is: <br />
                                        <li> <strong>Login</strong> to your account.</li>
                                        <li> Click the <strong>3 dots</strong> in the top right corner.</li>
                                        <li> Then click <strong>My Account</strong>.</li>
                                        <li> Scroll down and select <strong>Customize Invoice Template</strong>.</li>
                                        <li> You can select one of 2 options which are either
                                        <strong>Image based</strong> template or <strong>HTML based</strong> template.</li>
                                        <li> Select <strong>Image based template</strong> and then upload your
                                        template image sections as to the 4 categories.</li>
                                        <li> Or you can select the <strong>HTML based template</strong> and then
                                        add your desired info in the text field and
                                        customize it as needed.</li>
                                        <li> Then scroll down and click on the <strong>Update Information button</strong> to save it.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I share my invoice over the phone?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To share your invoice on Lean Finance all you need
                                        to do is: <br />
                                        <li> <strong>Login</strong> to your account.</li>
                                        <li> Go to the <strong>Sales page</strong> from the main menu.</li>
                                        <li> Find the invoice that you want to share and click on
                                        the <strong>More</strong> button.</li>
                                        <li> Then select <strong>Send Email</strong>, if you want to share the invoice via email, and add your desired email
                                        address.</li>
                                        <li> Or select <strong>Share Invoice</strong> to get a link that can be shared via <strong>SMS</strong> or by clicking WhatsApp which will open the <strong>WhatsApp</strong> application to use.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I display my tax budget?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To view your tax budget you can easily display it
                                        from the Dashboard page under the Tax Budget button.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I know what an option does in My Account
                                        page?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To know what a setting does in My Account page on
                                        Lean Finance all you need to do is: <br /> 
                                        <li> <strong>Login</strong> to your account. </li>
                                        <li> Click the <strong>3 dots</strong> in the top right corner.</li>
                                        <li> Then click <strong>My Account</strong>.</li>
                                        <li> Our team made sure that your experience is as simple
                                        as possible by adding videos next to each setting to
                                        learn about them and how to use it step-by-step.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I restrict permissions for certain users?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Once you have created all the users from the Users
                                        page under settings in Lean Finance, you can: 
                                        <li> Find the user that you want give or edit their
                                        permission. </li>
                                        <li> Click the Permission button and there you can add or
                                        remove any <strong>permission</strong> for this user. </li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I add a new client?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To add a client on Lean Finance all you need to do
                                        is: 
                                        <li> <strong>Login</strong> to your account.</li>
                                        <li> Go to the <strong>Clients</strong> page from the main menu. </li>
                                        <li> Click the <strong>Add Client</strong> Button.</li>
                                        <li> Fill in the needed information. </li>
                                        <li> Click <strong>Create</strong> to add. </li>
                                        <li> Newly added <strong>Clients</strong> are listed in the <strong>Clients</strong> page.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can I customize a label / field naming?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        To customize any label / field naming in Lean
                                        Finance all you need to do is: 
                                        <li> <strong>Login</strong> to your account. </li>
                                        <li> Click the <strong>3 dots</strong> in the top right corner.</li>
                                        <li> Then click <strong>My Account</strong>.</li>
                                        <li> Scroll down and select from the many label naming
                                        settings to change as needed.</li>
                                        <li> Then click <strong>Update Information</strong> to save.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        Is the Lean Finance software secure?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Lean Finance is a secured software by local and
                                        international cloud hosting standards to ease your
                                        mind.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        Why should I use an online e-invoicing software?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        With an online e-invoicing software you can easily
                                        have access to it from anywhere, anytime and on any
                                        device.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        How can online e-invoicing softwares help
                                        businesses?{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        Lean Finance is an online e-invoicing software that
                                        helps small, medium and large businesses in
                                        digitizing, simplifying, expediting, managing and
                                        automating their invoicing processes.
                                        <br />
                                        Making your work flow more organized and efficient
                                        to ensure faster results and a better client
                                        experience.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        Who should use an online e-invoicing software?
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        When you have a business up and running you will
                                        need to charge and invoice your clients and so it is
                                        essential to use a software such as Lean Finance to
                                        help you run your business.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <hr />
                        </AccordionDetails>
                    </Accordion>
                
                </div>
            </div>
        );
    } else {
        return (
            <div className="Ten">
                <div className="container">
                    
                    <Accordion
                        sx={{
                            borderTop: "none",
                            borderBottom: "none",
                            boxShadow: "none",
                            borderRadius: "0",
                            borderColor: "#BCBEC0",
                            py: 5,
                        }}
                    >
                        <AccordionSummary
                            expandIcon={
                                <ExpandMoreIcon
                                    color="secondary"
                                    fontSize="large"
                                    sx={{
                                        "&:hover": {
                                            color: "primary.main",
                                        },
                                    }}
                                />
                            }
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography
                                sx={{
                                    fontWeight: "700",
                                    fontSize: "40px",
                                    lineHeight: "64px",
                                    color: "text.secondary",
                                    textAlign: "center",
                                    mb: 20,
                                    width : "100%"
                                }}
                            >
الأسئلة الشائعة
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                                <hr />
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        ما المقصود بالبرمجيات كخدمة (SaaS)؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                    هو نموذج برمجي قائم على السحابة يتيح للمستخدمين الدخول إليه بسهولة من أي مكان.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        ما هو برنامج الفوترة الإلكترونية عبر الإنترنت ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                    هو برنامج قائم على السحابة يتيح لك القيام بجميع العمليات وتخزين الفواتير دون الحاجة إلى وجودها على أجهزتك.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        ما هي ZATCA؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                    هي هيئة الزكاة والضريبة والجمارك في المملكة العربية السعودية والتي لديها المتطلبات لازمة للفواتير .
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        ما هي الفواتير المعتمدة من هيئة الزكاة والضريبة والجمارك؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        هي الفواتير التي تم إنشاؤها من برنامج فوترة إلكترونية معتمدة ومربوطة بمنصة الهيئة.
                                        <br />
                                        وهي تشمل رقم التسجيل الضريبي للشركة ورمز QR الذي يتم إنشاؤه تلقائيا.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني إصدار فاتورة أو إشعار مدين أو دائن ؟{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لإصدار فاتورة أو اشعار مدين أو دائن من لين فايننس كل ما عليك فعله هو: <br />
                                        <li> <strong>تسجيل الدخول</strong> إلى حسابك.</li>
                                        <li> انتقل إلى صفحة <strong>المبيعات</strong> من القائمة الرئيسية .</li>
                                        <li> انقر فوق الزر " <strong>إنشاء فاتورة</strong> ".</li>
                                        <li> املأ المعلومات المطلوبة .</li>
                                        <li> انقر على <strong>إنشاء</strong> لإصدار فاتورتك .</li>
                                        <li> <strong>يتم سرد فواتير</strong> المنشأة فى <strong>صفحة المبيعات</strong> </li>
                                        <li> تتم نفس العملية <strong>لإشعارات الدائن والمدين </strong> .</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني إضافة منتجات لفواتيري ؟{" "}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لإضافة منتج على لين فايننس كل ما عليك فعله هو: <br /> 
                                        <li> <strong>تسجيل الدخول</strong> إلى حسابك. </li>
                                        <li> انتقل إلى صفحة <strong>المنتجات</strong> من القائمة الرئيسية .</li>
                                        <li> انقر فوق الزر <strong>"إضافة منتج"</strong>.</li>
                                        <li> املأ المعلومات المطلوبة .</li>
                                        <li>انقر فوق <strong>إنشاء منتج</strong> لإضافة منتجك .</li>
                                        <li> <strong>يتم سرد المنتجات</strong> المضافة حديثا في <strong>صفحة المنتجات</strong></li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني تخصيص نموذج الفاتورة الخاص بي؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لتخصيص نموذج الفاتورة الخاص بك على لين فايننس ، كل ما عليك فعله هو: <br />
                                        <li> <strong>تسجيل الدخول</strong> إلى حسابك. </li>
                                        <li> انقر فوق الثلاث نقاط في أعلى يسار الشاشة</li>
                                        <li> ثم انقر على <strong>حسابي</strong> .</li>
                                        <li> <strong>قم</strong> بالتمرير لأسفل وحدد <strong> نموذج فاتورة مخصص </strong> .</li>
                                        <li>يمكنك الاختيار إما قالب يستند <strong>إلى صورة</strong> أو قالب يستند <strong>إلى HTML</strong> .</li>
                                        <li>  حدد القالب المستند إلى الصور ثم <strong>قم</strong> بتحميل أقسام صورة القالب الخاصة بك المكون من 4 فئات .</li>
                                        <li>أو يمكنك تحديد القالب المستند <strong>إلى HTML</strong> ثم إضافة المعلومات التي تريدها في حقل النص وتخصيصها حسب الحاجة.</li>
                                        <li>ثم قم بالتمرير لأسفل وانقر على زر تحديث البيانات لحفظه .</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني مشاركة فاتورتي عبر الهاتف؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لمشاركة فاتورتك في لين فايننس ، كل ما عليك فعله هو: <br />
                                        <li> <strong>تسجيل الدخول</strong> إلى حسابك.</li>
                                        <li> انتقل إلى <strong>صفحة المبيعات</strong> من القائمة الرئيسية .</li>
                                        <li> ابحث عن الفاتورة التي تريد مشاركتها وانقر على زر <strong>المزيد</strong>.</li>
                                        <li> ثم حدد <strong>إرسال بريد إلكتروني</strong> ، إذا كنت ترغب في مشاركة الفاتورة عبر البريد الإلكتروني ، وإضافة عنوان البريد الإلكتروني المطلوب .</li>
                                        <li> أو حدد <strong>مشاركة الفاتورة</strong> للحصول على رابط يمكن مشاركته عبر <strong>الرسائل القصيرة</strong> أو بالنقر فوق <strong>WhatsApp</strong> الذي سيفتح تطبيق واتساب للاستخدام .</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني عرض ميزانيتي الضريبية؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لعرض ميزانيتك الضريبية ، يمكنك عرضها بسهولة من صفحة لوحة التحكم أسفل زر الميزانية الضريبية .
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني معرفة ما يفعله اعداد في صفحة حسابي ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لمعرفة ما يفعله اعداد في صفحة حسابي على لين فايننس ، كل ما عليك فعله هو: <br /> 
                                        <li> <strong>تسجيل الدخول</strong> إلى حسابك .</li>
                                        <li> انقر فوق الثلاث نقاط في أعلى يسار الشاشة .</li>
                                        <li>  ثم انقر على <strong>حسابي</strong> .</li>
                                        <li> حرص فريقنا على أن تكون تجربتك بسيطة قدر الإمكان عن طريق إضافة مقاطع فيديو بجوار كل إعداد للتعريف به وكيفية استخدامه خطوة بخطوة.</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني تقييد الصلاحيات لمستخدمين معينين ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        بمجرد إنشاء جميع المستخدمين من صفحة المستخدمي المدرجة تحت الاعدادات في لين فايننس ، يمكنك :
                                        <li> البحث عن المستخدم الذي تريد منحه أو تعديل الصلاحيات له . </li>
                                        <li> انقر فوق زر <strong>الصلاحيات</strong> وهناك يمكنك إضافة أو إزالة أي صلاحية لهذا المستخدم. </li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني إضافة عميل جديد ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لإضافة عميل في لين فايننس كل ما عليك فعله هو:
                                        <li> <strong>تسجيل الدخول</strong> إلى حسابك.</li>
                                        <li> انتقل إلى صفحة <strong>العملاء</strong> من القائمة الرئيسية . </li>
                                        <li> انقر فوق الزر <strong>"إضافة عميل"</strong> .</li>
                                        <li> املأ المعلومات المطلوبة .</li>
                                        <li> انقر فوق <strong>إنشاء</strong> للإضافة . </li>
                                        <li> يتم سرد <strong>العملاء المضافين</strong> حديثا في صفحة <strong>العملاء</strong> .</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكنني تخصيص تسمية / حقل ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لتخصيص أي تسمية / حقل في لين فايننس ، كل ما عليك فعله هو:
                                        <li> <strong>تسجيل الدخول </strong>إلى حسابك. </li>
                                        <li> انقر فوق الثلاث نقاط في أعلى يسار الشاشة .</li>
                                        <li>  ثم انقر على <strong>حسابي</strong> .</li>
                                        <li>  <strong>قم</strong> بالتمرير لأسفل واختر من بين العديد من إعدادات التسمية لتغييرها حسب الحاجة.</li>
                                        <li> ثم اضغط <strong>تحديث البيانات</strong> للحفظ .</li>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        هل برنامج لين فايننس آمن؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لين فايننس هو برنامج آمن وفقا لمعايير الاستضافة السحابية المحلية والدولية لراحة بالك.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        لماذا يجب علي استخدام برنامج الفوترة الإلكترونية عبر الإنترنت ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        باستخدام برنامج الفوترة الإلكترونية عبر الإنترنت ، ستتمكن من الدخول اليه بسهولة من أي مكان وفي أي وقت ومن خلال أي جهاز.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        كيف يمكن لبرامج الفوترة الإلكترونية عبر الإنترنت مساعدة الشركات؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        لين فايننس هو عبارة عن برنامج للفوترة الإلكترونية عبر الإنترنت يساعد الشركات الصغيرة والمتوسطة والكبيرة على رقمنة عمليات فواتيرها وتبسيطها وتسريعها وإدارتها وتشغيلها آليا .
                                        <br />
                                        جعل تدفق عملك أكثر تنظيما وكفاءة لضمان نتائج أسرع وتجربة أفضل للعميل .
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <Accordion
                                sx={{
                                    borderTop: "none",
                                    borderBottom: "none",
                                    boxShadow: "none",
                                    borderRadius: "0",
                                    borderColor: "#BCBEC0",
                                    py: 5,
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            color="secondary"
                                            fontSize="large"
                                            sx={{
                                                "&:hover": {
                                                    color: "primary.main",
                                                },
                                            }}
                                        />
                                    }
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: "400",
                                            fontSize: "28px",
                                        }}
                                    >
                                        من يجب أن يستخدم برنامج الفوترة الإلكترونية عبر الإنترنت ؟
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        عندما يكون لديك نشاط تجاري ، فستحتاج إلى فرض رسوم على عملائك وإصدار فاتورة لهم ، لذا من الضروري استخدام برنامج مثل لين فايننس لمساعدتك في إدارة عملك.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                            <hr />
                        </AccordionDetails>
                    </Accordion>
                
                </div>
            </div>
        );
    }
}

export default Home;
